import { styled, css } from "styled-components";
import media from "../../../../styles/mediaQueries";
import Colors from "../../../../styles/Colors";
export const StyledSidebarNavMenuTrigger = styled.li `
  padding: 0 14px;
  position: relative;
  margin-bottom: 10px;
  cursor: pointer;
  overflow: hidden;

  ${(props) => props.isActive &&
    css `
      background: ${props.blackFridayTheme
        ? Colors.WHITE_2024
        : Colors.PROFILE_RED_2024};
      color: #000;
      svg {
        fill: #000 !important;
      }
      span {
        color: #000 !important;
      }
    `}

  &:hover {
    background: ${({ blackFridayTheme }) => blackFridayTheme ? Colors.WHITE_2024 : Colors.PROFILE_RED_2024};
    color: ${({ blackFridayTheme }) => blackFridayTheme ? Colors.BLACK_2024 : Colors.WHITE_2024};
    svg {
      fill: ${({ blackFridayTheme }) => blackFridayTheme ? Colors.BLACK_2024 : Colors.WHITE_2024} !important;
    }
    span {
      color: ${({ blackFridayTheme }) => blackFridayTheme ? Colors.BLACK_2024 : Colors.WHITE_2024} !important;
    }
  }

  &:before {
    transition: all 0.4s cubic-bezier(0.46, 0.03, 0.52, 0.96);
    position: absolute;
    right: -40px;
    top: 50%;
    margin-top: -15px;
    content: "";
    width: 0;
    height: 0;
    border-top: 15px solid transparent;
    border-bottom: 15px solid transparent;
    border-right: 15px solid #efefef;

    ${media.up("small") `
      border-top: 25px solid transparent;
      border-bottom: 25px solid transparent;
      border-right: 25px solid #efefef;
      margin-top: -25px;
    `}
  }
  ${media.down("belowSmall") `
    margin-bottom: 0;
  `}
  ${media.up("small") `
    &:hover {
      &:before {
        right: -10px;
      }
    }
  `}
  ${media.up("large") `
    padding: 0 25px;
    &:hover {
      &:before {
        right: -2px;
      }
    }
  `}

  ${media.only("small", "belowMedium") `
    padding: 0 15px;
    margin-bottom: 0;
  `}
  ${media.only("medium", "belowLarge") `
    padding: 0 15px;
  `}
  ${media.only("large", "xlarge") `
    padding: 0 15px;
    margin-bottom: 3px!important;
  `}
`;
export const StyledSidebarNavLink = styled.a `
  display: flex;
  align-content: center;
  width: 100%;
  color: #fff;
  text-transform: none;
  font-weight: 400;
  padding: 10px 0;
  font-size: 16px;
  line-height: 190%;
  height: 58px;

  ${media.only("medium", "belowLarge") `
    font-size: 14px;
    padding: 6px 0;
  `}
  ${media.only("medium", "belowLarge") `
    height: 45px;
  `}
  ${media.up("large") `
    height: 50px;
  `}
  ${media.only("large", "xlarge") `
    font-size: 14px;
  `}

  @media (max-height: 700px) {
    height: 48px;
  }
`;
export const StyledCustomSidebarNavLink = styled.div `
  display: flex;
  align-content: center;
  width: 100%;
  color: #fff;
  text-transform: none;
  font-weight: 400;
  padding: 10px 0;
  font-size: 16px;
  line-height: 190%;
  height: 58px;
  ${media.only("medium", "belowLarge") `
    font-size: 14px;
    padding: 6px 0;
  `}
  ${media.only("medium", "belowLarge") `
    height: 45px;
  `}
  ${media.up("large") `
    height: 50px;
  `}
  ${media.only("large", "xlarge") `
    font-size: 14px;
  `}

  @media (max-height: 700px) {
    height: 48px;
  }
`;
export const SidebarDivider = styled.li `
  position: relative;
  padding: 0 25px;
  margin: 0 14px 15px;
  height: 1px;
  background: ${({ blackFridayTheme }) => blackFridayTheme ? "rgba(255, 255, 255, 0.15)" : "rgba(0, 0, 0, 0.15)"};
  width: calc(100% - 28px);
  ${media.down("belowSmall") `
    display: none;
  `}
  ${media.only("medium", "belowLarge") `
    display: none;
  `}
  ${media.only("large", "xlarge") `
    padding: 0 15px;
    margin-bottom: 3px;
  `}
`;
export const StyledSidebarNavButton = styled(StyledSidebarNavLink) `
  text-decoration: none;
  width: 100%;
  text-align: left;
  height: auto;
  cursor: pointer;
  border: none;
  outline: 0;
  background: 0 0;
  appearance: none;
  margin: initial;
  font-weight: 400;

  ${media.only("medium", "belowLarge") `
    height: auto;
  `}

  ${media.up("large") `
    height: auto;
  `}
`;
export const SidebarNavIcon = styled.span `
  width: 50px;
  display: flex;
  align-self: center;
  align-items: center;
  height: 100%;
  svg {
    width: 30px;
    min-width: 30px;
    height: 30px;
    margin-right: 15px;

    ${(props) => !props.noIconSvgEffects &&
    css `
        color: ${props.blackFridayTheme
        ? Colors.WHITE_2024
        : Colors.BLACK_2024};
        fill: ${props.blackFridayTheme ? Colors.WHITE_2024 : Colors.BLACK_2024};
      `}
  }

  ${media.only("medium", "belowLarge") `
    width: 43px;
    svg {
      width: 25px;
      min-width: 25px;
      height: 25px;
    }
  `}
  ${media.up("large") `
    width: 49px;
  `}

  ${media.only("large", "xlarge") `
    width: 40px;
    svg {
      width: 25px;
      min-width: 25px;
      height: 25px;
    }
  `}
`;
export const SidebarNavText = styled.span `
  display: flex;
  width: calc(100% - 50px);
  line-height: 1.25em;
  padding-top: 4px;
  color: ${({ blackFridayTheme }) => blackFridayTheme ? Colors.WHITE_2024 : Colors.BLACK_2024};
  height: 100%;
  align-self: center;
  align-items: center;
  ${media.up("large") `
    width: calc(100% - 49px);
  `}
  ${media.only("medium", "belowLarge") `
    width: calc(100% - 43px);
  `}
  ${media.only("large", "xlarge") `
    width: calc(100% - 40px);
  `}
  ${media.down("belowMedium") `
    ${(props) => props.isExtended &&
    css `
        display: none;
      `}
  `}
`;
export const SidebarNavItem = styled.li `
  padding: 0 14px;
  position: relative;
  margin-bottom: 10px;
  &:hover {
    background: ${({ blackFridayTheme }) => blackFridayTheme ? Colors.WHITE_2024 : Colors.PROFILE_RED_2024};
    span {
      color: ${({ blackFridayTheme }) => blackFridayTheme ? Colors.BLACK_2024 : Colors.WHITE_2024};
    }
    ${(props) => !props.noIconSvgEffects &&
    css `
        span svg {
          fill: ${props.blackFridayTheme
        ? Colors.BLACK_2024
        : Colors.WHITE_2024};
        }
        span svg[data-icon="calendar"] {
          color: ${props.blackFridayTheme
        ? Colors.BLACK_2024
        : Colors.WHITE_2024};
        }
      `}
  }

  ${media.up("large") `
    padding: 0 25px;
  `}
  @media (max-height: 700px) {
    margin-bottom: 2px;
  }
  ${media.only("small", "belowMedium") `
    padding: 0 15px;
    margin-bottom: 0;
  `}
  ${media.only("medium", "belowLarge") `
    padding: 0 15px;
  `}
  ${media.only("large", "xlarge") `
    padding: 0 15px;
    margin-bottom: 3px!important;
  `}

  ${({ active, noIconSvgEffects, blackFridayTheme }) => active &&
    css `
      background: ${blackFridayTheme ? Colors.WHITE_2024 : Colors.PROFILE_RED_2024};
      span,
      svg {
        color: ${blackFridayTheme ? Colors.BLACK_2024 : Colors.WHITE_2024}; !important;
      }
      ${!noIconSvgEffects &&
        css `
        span svg {
          fill: ${blackFridayTheme ? Colors.BLACK_2024 : Colors.WHITE_2024}; !important;
        }
      `}
    `}
`;
export const StyledSidebarNav = styled.ul `
  position: relative;
  list-style: none;
  margin: 50px 0 0;
  width: 100%;
  padding: 0;
  @media (max-height: 700px) {
    margin-top: 35px;
  }
`;
//# sourceMappingURL=style.js.map